<template>
    <div style="height: 100%;">
        <!-- BEGIN: Header-->
        <div class="navbar-header sticky-top" style="z-index: 3">
            <router-link class="navbar-brand" :to="{name: 'home'}">
                <inline-svg v-if="$mq === 'xs'" class="me-1" src="/assets/img/logo/logo_small.svg"/>
                <inline-svg v-else class="me-1" src="/assets/img/logo/logo_with_text.svg"/>
            </router-link>
            <div class="navbar-buttons text-right">
                <div>
                    <btn class="btn-outline-primary" @click="redirectToAddCardDeck">
                        <inline-svg class="me-1" src="/assets/img/icons/file-plus-01-primary.svg"></inline-svg>
                        Create a New Card Deck
                    </btn>
                </div>
                <div class="text-center d-flex justify-content-center align-items-center">
                    <a class="link-primary auth-gray-text auth-back"
                       @click.prevent="$modal.show('cardDeckTutorialModal')" href="#">
                        <inline-svg class="me-1" src="/assets/img/icons/help-circle.svg"/>
                        Help
                    </a>
                </div>
<!--                <div>-->
<!--                    <tippy-->
<!--                        :ref="'notificationsMenu'"-->
<!--                        trigger="click"-->
<!--                        placement="bottom"-->
<!--                        :arrow="false"-->
<!--                        :interactive="true"-->
<!--                        theme="light"-->
<!--                        :animateFill="false"-->
<!--                        :onTrigger="loadNotifications()"-->
<!--                    >-->
<!--                        <div style="max-width: 500px">-->
<!--                            <div class="dropdown-menu__title">-->
<!--                                <span>Notifications</span>-->
<!--                                <button type="button" class="btn-close" style="height: 10px; width: 10px" data-dismiss="modal" aria-hidden="true"-->
<!--                                        @click="$refs['notificationsMenu'].tip.hide()"></button>-->
<!--                            </div>-->
<!--                            <div class="dropdown-menu__menu-item text-nowrap">-->
<!--                                <NotificationMenuItem :user="user" :time-ago="timeAgo"></NotificationMenuItem>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <template #trigger>-->
<!--                            <inline-svg class="me-1" style="cursor: pointer" src="/assets/img/icons/bell-01.svg"/>-->
<!--                        </template>-->
<!--                    </tippy>-->
<!--                </div>-->
                <tippy
                        :ref="'userMenu'"
                        trigger="click"
                        placement="bottom"
                        :arrow="false"
                        :interactive="true"
                        theme="light"
                        :animateFill="false"
                >
                    <div>
                        <div class="dropdown-menu__menu-item">
                            <user-avatar id="avatar" :user="user" displayName="true" displayEmail="true"></user-avatar>
                        </div>
                        <router-link :to="{name: 'account'}" class="dropdown-menu__menu-item menu-item-divider">
                            <inline-svg src="/assets/img/icons/user01.svg"></inline-svg>
                            View profile
                        </router-link>
                        <div class="dropdown-menu__menu-item">
                            <inline-svg src="/assets/img/icons/settings01.svg"></inline-svg>
                            Settings
                        </div>
                        <div class="dropdown-menu__menu-item menu-item-divider">
                            <inline-svg src="/assets/img/icons/user-plus01.svg"></inline-svg>
                            Invite colleagues
                        </div>
                        <a @click.prevent="logout" href="#" class="dropdown-menu__menu-item menu-item-divider">
                            <inline-svg src="/assets/img/icons/logout01.svg"></inline-svg>
                            Log out
                        </a>
                    </div>
                    <template #trigger>
                        <user-avatar style="cursor: pointer" :user="user"></user-avatar>
                    </template>
                </tippy>
            </div>
        </div>
        <!-- END: Header-->
        <!-- BEGIN: Main Menu-->
        <div class="main-menu menu-light menu-fixed"
             @mouseover="hoverMenu(true)"
             @mouseleave="hoverMenu(false)"
             :class="{'expanded': menuHover || menuExpanded}"
             data-scroll-to-active="true">
            <div class="main-menu-content">
                <VuePerfectScrollbar class="scroll-area" v-once :settings="{maxScrollbarLength: 60}">
                    <div class="d-flex flex-column minh-100">
                        <ul class="navigation navigation-main" id="main-menu-navigation" style="flex: 1;">
                            <menu-item svg="/assets/img/icons/home-line.svg" :label="'Home'" :to="{ name: 'home'}"/>
                            <menu-item svg="/assets/img/icons/file-heart-01.svg" :label="'My Card Decks'" :to="{ name: 'card.decks'}"/>
                            <menu-item svg="/assets/img/icons/face-smile.svg" :label="'Heroes'" :to="{ name: 'heroes'}"/>
                            <menu-item svg="/assets/img/icons/globe-01.svg" :label="'Community Library'"
                                       :to="{ name: 'community.library'}"/>
                        </ul>
                        <tippy
                            :ref="'disclaimer'"
                            trigger="mouseenter"
                            placement="top"
                            :arrow="true"
                            :interactive="true"
                            theme="light"
                            :animateFill="false"
                        >
                            <div>
                                <div class="powered-by-tooltip" style="max-width: 300px">
                                    <div class="powered-by-tooltip__title">By the way...</div>
                                    <div style="text-align: left">
                                        'Thank you M&T Bank for sponsoring development of MagnusTeams.
                                        <br><br><strong>Note:</strong> There is no connection to M&T Bank systems/software and M&T Bank is not collecting any personal data.'
                                    </div>
                                </div>
                            </div>
                            <template #trigger>
                                <div class="powered-by">
                                    Dashboard powered by
                                    <inline-svg title="My Image" id="mt_logo" class="me-1" src="/assets/img/logo/m&t-logo.svg"
                                                :keepDuringLoading="false"/>
                                </div>
                            </template>
                        </tippy>

                        <span class="text-danger">Version 1.5</span>
                    </div>
                </VuePerfectScrollbar>
            </div>
        </div>
        <!-- END: Main Menu-->
        <div class="app-content content">
            <div class="content-overlay"></div>
            <div class="content-wrapper">
                <page-header></page-header>
                <div class="content-body">
                    <keep-alive :include="['Home']">
                        <router-view :key="$route.path"></router-view>
                    </keep-alive>
                </div>
            </div>
        </div>
        <card-deck-tutorial :user="user"></card-deck-tutorial>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import { tippy } from "vue-tippy";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import MenuItem from '@/components/theme/MenuItem'
import MenuDropdown from '@/components/theme/MenuDropdown'
import MenuSection from '@/components/theme/MenuSection'
import UserAvatar from "@/components/UserAvatar.vue";
import CardDeckTutorial from "@/components/CardDeckTutorial.vue";
import PageHeader from "@/components/theme/PageHeader.vue";
import moment from "moment";
import NotificationMenuItem from "@/components/NotificationMenuItem.vue";

export default {
  name: 'layout',
  components: {
      NotificationMenuItem,
      PageHeader, CardDeckTutorial, UserAvatar, MenuItem, MenuDropdown, MenuSection, VuePerfectScrollbar},
  data: function () {
    return {
      loading: {
        notifications: false,
      },
      menuExpanded: true,
      menuCollapsed: false,
      menuHover: false,
      menuHidden: false,
      notifications: [],
      menu_items: {
        'default': {
          'routes': [],
        }
      },
      version: window.version,
    }
  },
  watch: {
    menuExpanded(value) {
      if (value) {
        $('body').addClass('menu-expanded').removeClass('menu-collapsed');
      } else {
        $('body').removeClass('menu-expanded').addClass('menu-collapsed');
      }
      localStorage.setItem('menuExpanded', value)
    },
    $route (to, from) {
      if (this.$refs && this.$refs['userMenu']) {
        this.$refs['userMenu'].tip.hide();
      }
      if (this.$refs && this.$refs['notificationsMenu']) {
          this.$refs['notificationsMenu'].tip.hide();
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      meta: state => state.meta,
      settings: state => state.settings,
    }),
      timeAgo() {
        return moment('Thu Oct 25 2018 17:30:03 GMT+0300').fromNow();
      }
  },
  created() {
    // this.computeMenu();
    this.$router.beforeEach((to, from, next) => {
      this.closeMenu();
      next();
    })
  },
  mounted() {
    $('body').removeClass('2-columns bg-full-screen-image blank-page 1-column');

    $('body').attr('data-col', '2-columns');
    // initscrolls();
    this.onResize();
    let self = this;
    this.$events.$on('toggleMenu', eventData => {
      if (typeof eventData !== 'undefined') {
        if (eventData) {
          this.openMenu()
        } else {
          this.closeMenu()
        }
      } else {
        this.toggleMenu()
      }
    });
    window.addEventListener('resize', function (e) {
      self.onResize(e);
    });

    if (this.menuExpanded) {
      $('body').addClass('menu-expanded').removeClass('menu-collapsed');
    } else {
      $('body').removeClass('menu-expanded').addClass('menu-collapsed');
    }
    this.menuExpanded = localStorage.getItem('menuExpanded') ? JSON.parse(localStorage.getItem('menuExpanded')) : false;

    if (!this.user.tutorial_viewed) {
        this.$modal.show('cardDeckTutorialModal')
    }
  },
  destroyed() {
    this.$events.$off('toggleMenu');
  },
  methods: {
    computeMenu() {
      this.$router.options.routes.forEach((route) => {
        if (!route.meta.isMain) {
          return;
        }
        this.computeMenuChildren(route);
      })
    },
    computeMenuChildren(route, index = 'default') {
      if (route.meta.visible) {
        let section = route.meta.section !== undefined ? route.meta.section : 'default';
        if (!this.menu_items[section]) {
          this.menu_items[section] = [];
        }

        let group = route.meta.group !== undefined ? route.meta.group : null;
        if (group && !this.menu_items[section][group]) {
          this.menu_items[section][group] = {
            'type': 'group',
            'routes': []
          };
        }
        if (group) {
          this.menu_items[section][group].routes.push(route);
        } else {
          this.menu_items[section].push({
            'type': 'route',
            'routes': route
          });
        }
      }
      if (route.children) {
        route.children.forEach((route2) => {
          this.computeMenuChildren(route2)
        });
      }
    },
    onResize(e) {
      let width = window.innerWidth;
      if (width < 800) {
        $('body').addClass('vertical-overlay-menu').removeClass('vertical-menu-modern');
        this.hideMenu();
      } else if (width >= 800) {
        $('body').removeClass('vertical-overlay-menu').addClass('vertical-menu-modern');
        this.openMenu();
      }
    },
    transit: function (callback1, callback2) {
      $('body').addClass('changing-menu');

      callback1.call();

      if ($('body').hasClass('vertical-layout')) {
        if ($('body').hasClass('menu-open') || $('body').hasClass('menu-expanded')) {
          $('.menu-toggle').addClass('is-active');

          // Show menu header search when menu is normally visible
          if ($('body').data('menu') === 'vertical-menu') {
            if ($('.main-menu-header')) {
              $('.main-menu-header').show();
            }
          }
        } else {
          $('.menu-toggle').removeClass('is-active');

          // Hide menu header search when only menu icons are visible
          if ($('body').data('menu') === 'vertical-menu') {
            if ($('.main-menu-header')) {
              $('.main-menu-header').hide();
            }
          }
        }
      }

      setTimeout(function () {
        callback2.call();
        $('body').removeClass('changing-menu');

        // menuObj.update();
      }, 500);
    },
    toggleMenu() {
      let width = window.innerWidth;
      if (width < 1200) {
        if (this.menuExpanded) {
          this.hideMenu();
        } else {
          this.openMenu();
        }
      } else if (width >= 1200) {
        if (this.menuExpanded) {
          this.collapseMenu();
        } else {
          this.expandMenu();
        }
      }
    },
    hideMenu() {
      this.transit(() => {
        $('body').removeClass('menu-open menu-expanded').addClass('menu-hide');
        this.menuHidden = true;
        this.menuExpanded = false;

        if ($('body').hasClass('vertical-overlay-menu')) {
          $('.sidenav-overlay').removeClass('d-block').addClass('d-none');
          $('body').css('overflow', 'auto');
        }
      }, () => {
        // if (!$('.main-menu').hasClass('menu-native-scroll') && $('.main-menu').hasClass('menu-fixed')) {
        //     this.manualScroller.enable();
        // }

        if (!$('body').hasClass('vertical-overlay-menu')) {
          $('.sidenav-overlay').removeClass('d-block d-none');
          $('body').css('overflow', 'auto');
        }
      });
    },
    openMenu() {
      this.transit(() => {
        $('body').removeClass('menu-hide menu-collapsed').addClass('menu-open');
        this.menuHidden = false;
        this.menuExpanded = true;

        if ($('body').hasClass('vertical-overlay-menu')) {
          $('.sidenav-overlay').removeClass('d-none').addClass('d-block');
          $('body').css('overflow', 'hidden');
        }
      }, () => {
        if (!$('.main-menu').hasClass('menu-native-scroll') && $('.main-menu').hasClass('menu-fixed')) {
          // this.manualScroller.enable();
          $('.main-menu-content').css('height', $(window).height() - $('.header-navbar').height() - $('.main-menu-header').outerHeight() - $('.main-menu-footer').outerHeight());
          // this.manualScroller.update();
        }

        if (!$('body').hasClass('vertical-overlay-menu')) {
          $('.sidenav-overlay').removeClass('d-block d-none');
          $('body').css('overflow', 'auto');
        }
      });
    },
    expandMenu() {
      if (this.menuExpanded === false) {
        if ($('body').data('menu') == 'vertical-menu-modern') {
          $('.modern-nav-toggle').find('.toggle-icon')
            .removeClass('bx bx-circle').addClass('bx bx-disc');
        }
        this.transit(() => {
          $('body').removeClass('menu-collapsed').addClass('menu-expanded');
          this.menuCollapsed = false;
          this.menuExpanded = true;

          $('.sidenav-overlay').removeClass('d-block d-none');
        }, () => {

          if (($('.main-menu').hasClass('menu-native-scroll') || $('body').data('menu') == 'horizontal-menu')) {
            // this.manualScroller.disable();
          } else {
            if ($('.main-menu').hasClass('menu-fixed')) {
              // this.manualScroller.enable();
            }
          }

          if (($('body').data('menu') == 'vertical-menu' || $('body').data('menu') == 'vertical-menu-modern') && $('.main-menu').hasClass('menu-fixed')) {
            $('.main-menu-content').css('height', $(window).height() - $('.header-navbar').height() - $('.main-menu-header').outerHeight() - $('.main-menu-footer').outerHeight());
            // this.manualScroller.update();
          }

        });
      }
    },
    collapseMenu() {
      if (this.menuCollapsed === false) {
        if ($('body').data('menu') == 'vertical-menu-modern') {
          $('.modern-nav-toggle').find('.toggle-icon')
            .removeClass('bx bx-disc').addClass('bx bx-circle');
        }
        this.transit(() => {
          $('body').removeClass('menu-expanded').addClass('menu-collapsed');
          this.menuCollapsed = true;
          this.menuExpanded = false;

          $('.content-overlay').removeClass('d-block d-none');
        }, () => {

          if (($('body').data('menu') == 'horizontal-menu') && $('body').hasClass('vertical-overlay-menu')) {
            if ($('.main-menu').hasClass('menu-fixed')) {
              // this.manualScroller.enable();
            }
          }
          if (($('body').data('menu') == 'vertical-menu' || $('body').data('menu') == 'vertical-menu-modern') && $('.main-menu').hasClass('menu-fixed')) {
            $('.main-menu-content').css('height', $(window).height() - $('.header-navbar').height());
            // this.manualScroller.update();
          }
          if ($('body').data('menu') == 'vertical-menu-modern') {
            if ($('.main-menu').hasClass('menu-fixed')) {
              // this.manualScroller.enable();
            }
          }
        });
      }
    },
    hoverMenu(state) {
      if (this.menuExpanded) {
        return false;
      }
      this.menuHover = state;
    },
    closeMenu() {
      let width = window.innerWidth;
      if (width < 1200) {
        this.hideMenu();
      }
    },
    logout() {
      this.$auth.destroyToken();
      this.$role.removePermissions();
      this.$acl.change('public');
      this.$store.commit('logout');
      this.$router.push({name: 'login'})
    },
    redirectToAddCardDeck()
    {
      if (this.$route.name === 'card.decks') {
        this.$modal.show('addCardModal')
      } else {
        this.$router.push({ name: 'card.decks', params: {openAddCardDeck: 'open'}})
      }
    },
    loadNotifications()
    {
        this.loading.notifications = true;
        this.$http.get("/notifications/list", this.filters)
            .then((res) => {
                this.loading.notifications = false;
            })
            .catch((error) => {
                console.log(error)
                this.loading.notifications = false;
            });
    }
  }
}
</script>
